import { render } from 'preact';
import { GameApp } from './app/GameApp';
import './styles/global.css';

render(<GameApp />, document.getElementById('app')!);
